export const pageView = (rest) => {
  if (window && window.dataLayer) {
    window.dataLayer?.push({
      event: 'VirtualPageView',
      ...rest
    })
  }
}
